import { render } from "./OrgAdminDashboard.vue?vue&type=template&id=7fd5ec66&scoped=true"
import script from "./OrgAdminDashboard.vue?vue&type=script&lang=js"
export * from "./OrgAdminDashboard.vue?vue&type=script&lang=js"

import "./OrgAdminDashboard.vue?vue&type=style&index=0&id=7fd5ec66&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd5ec66"]])

export default __exports__